@if (locationLabel()) {
  <span class="__chip">
    {{ locationLabel() }}
  </span>
}
